import { SingleViewStateRecord } from '@common/data-models/records/single-viewstate-record';
import { ViewStateTypes } from "@common/enums/viewstate-types";

export class SingleTopicViewStateRecord extends SingleViewStateRecord {

    public initialize() {
        this.viewStateType = ViewStateTypes.SINGLETOPIC;
        super.initialize();
    }

    public get topicGuid(): string { return this.getAs<string>("topicGuid"); }
    public set topicGuid(value: string) { this.set("topicGuid", value); }
}
